import * as Card from './Card';
export default Card;
